// src/Calendar.tsx
import {
  defaultTimePickerTheme,
  TimePicker
} from "@react-shamsi/timepicker";

// ../../node_modules/@tabler/icons/icons-react/dist/index.esm.js
import * as e from "react";
function t() {
  return t = Object.assign ? Object.assign.bind() : function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var o2 = arguments[t2];
      for (var r in o2)
        Object.prototype.hasOwnProperty.call(o2, r) && (e2[r] = o2[r]);
    }
    return e2;
  }, t.apply(this, arguments);
}
function o(e2, t2) {
  if (null == e2)
    return {};
  var o2, r, n = function(e3, t3) {
    if (null == e3)
      return {};
    var o3, r2, n2 = {}, l2 = Object.keys(e3);
    for (r2 = 0; r2 < l2.length; r2++)
      o3 = l2[r2], t3.indexOf(o3) >= 0 || (n2[o3] = e3[o3]);
    return n2;
  }(e2, t2);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e2);
    for (r = 0; r < l.length; r++)
      o2 = l[r], t2.indexOf(o2) >= 0 || Object.prototype.propertyIsEnumerable.call(e2, o2) && (n[o2] = e2[o2]);
  }
  return n;
}
var jy = ["size", "color", "stroke"];
function By(r) {
  var n = r.size, l = void 0 === n ? 24 : n, i = r.color, a = void 0 === i ? "currentColor" : i, c = r.stroke, s = void 0 === c ? 2 : c, h = o(r, jy);
  return e.createElement("svg", t({ xmlns: "http://www.w3.org/2000/svg", className: "icon icon-tabler icon-tabler-calendar", width: l, height: l, viewBox: "0 0 24 24", strokeWidth: s, stroke: a, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }, h), e.createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), e.createElement("rect", { x: 4, y: 5, width: 16, height: 16, rx: 2 }), e.createElement("line", { x1: 16, y1: 3, x2: 16, y2: 7 }), e.createElement("line", { x1: 8, y1: 3, x2: 8, y2: 7 }), e.createElement("line", { x1: 4, y1: 11, x2: 20, y2: 11 }), e.createElement("line", { x1: 11, y1: 15, x2: 12, y2: 15 }), e.createElement("line", { x1: 12, y1: 15, x2: 12, y2: 18 }));
}
var vH = ["size", "color", "stroke"];
function mH(r) {
  var n = r.size, l = void 0 === n ? 24 : n, i = r.color, a = void 0 === i ? "currentColor" : i, c = r.stroke, s = void 0 === c ? 2 : c, h = o(r, vH);
  return e.createElement("svg", t({ xmlns: "http://www.w3.org/2000/svg", className: "icon icon-tabler icon-tabler-chevron-left", width: l, height: l, viewBox: "0 0 24 24", strokeWidth: s, stroke: a, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }, h), e.createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), e.createElement("polyline", { points: "15 6 9 12 15 18" }));
}
var kH = ["size", "color", "stroke"];
function wH(r) {
  var n = r.size, l = void 0 === n ? 24 : n, i = r.color, a = void 0 === i ? "currentColor" : i, c = r.stroke, s = void 0 === c ? 2 : c, h = o(r, kH);
  return e.createElement("svg", t({ xmlns: "http://www.w3.org/2000/svg", className: "icon icon-tabler icon-tabler-chevron-right", width: l, height: l, viewBox: "0 0 24 24", strokeWidth: s, stroke: a, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }, h), e.createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), e.createElement("polyline", { points: "9 6 15 12 9 18" }));
}
var YO = ["size", "color", "stroke"];
function ZO(r) {
  var n = r.size, l = void 0 === n ? 24 : n, i = r.color, a = void 0 === i ? "currentColor" : i, c = r.stroke, s = void 0 === c ? 2 : c, h = o(r, YO);
  return e.createElement("svg", t({ xmlns: "http://www.w3.org/2000/svg", className: "icon icon-tabler icon-tabler-clock", width: l, height: l, viewBox: "0 0 24 24", strokeWidth: s, stroke: a, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }, h), e.createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), e.createElement("circle", { cx: 12, cy: 12, r: 9 }), e.createElement("polyline", { points: "12 7 12 12 15 15" }));
}

// src/Calendar.tsx
import classNames5 from "classnames";
import {
  addMonths,
  format as format2,
  getMonth as getMonth3,
  setMonth,
  setYear,
  subMonths
} from "date-fns-jalali";
import { convertDigits as convertDigits4 } from "persian-helpers";
import { forwardRef, useEffect as useEffect2, useMemo as useMemo4, useState as useState2 } from "react";
import { SwitchTransition, Transition } from "react-transition-group";

// src/Footer.tsx
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
var Footer = ({
  themeClasses,
  onCancel,
  mode,
  onChangeMode,
  onConfirm,
  showTimePicker
}) => {
  return /* @__PURE__ */ jsxs("div", {
    style: {
      color: themeClasses.footerButtonColor,
      backgroundColor: themeClasses.footerBackgroundColor
    },
    className: classNames("w-full p-6 flex items-center"),
    children: [
      /* @__PURE__ */ jsx("button", {
        onClick: onConfirm,
        className: "ml-6",
        children: "\u062A\u0627\u06CC\u06CC\u062F"
      }),
      /* @__PURE__ */ jsx("button", {
        onClick: onCancel,
        children: "\u0627\u0646\u0635\u0631\u0627\u0641"
      }),
      showTimePicker && /* @__PURE__ */ jsx("button", {
        className: "mr-auto",
        onClick: () => onChangeMode == null ? void 0 : onChangeMode(mode === "date" ? "time" : "date"),
        children: mode === "date" ? /* @__PURE__ */ jsx(ZO, {
          className: "w-5 h-5"
        }) : /* @__PURE__ */ jsx(By, {
          className: "w-5 h-5"
        })
      })
    ]
  });
};
var Footer_default = Footer;

// src/Header.tsx
import { format, getDate, getMonth, isToday } from "date-fns-jalali";
import { convertDigits } from "persian-helpers";
import { useMemo } from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Header = ({
  activeDate,
  onGoToToday,
  showGoToToday,
  selectedDate,
  months,
  themeClasses
}) => {
  const activeDateToJalali = useMemo(
    () => ({
      day: convertDigits(getDate(activeDate)),
      dayOfWeek: format(activeDate, "EEEE")
    }),
    [activeDate]
  );
  return /* @__PURE__ */ jsxs2("div", {
    style: {
      color: themeClasses.headerTextColor,
      backgroundColor: themeClasses.headerBackgroundColor
    },
    className: "w-full py-6 px-4 flex items-center",
    children: [
      /* @__PURE__ */ jsx2("h1", {
        className: "text-5xl font-bold ml-2",
        children: activeDateToJalali == null ? void 0 : activeDateToJalali.day
      }),
      /* @__PURE__ */ jsxs2("h2", {
        className: "text-base",
        children: [
          months[getMonth(activeDate)],
          "\u060C ",
          activeDateToJalali == null ? void 0 : activeDateToJalali.dayOfWeek
        ]
      }),
      showGoToToday && !isToday(selectedDate) && /* @__PURE__ */ jsx2("button", {
        onClick: onGoToToday,
        className: "px-4 py-2 rounded-md bg-white text-black mr-auto text-sm",
        children: "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632"
      })
    ]
  });
};
var Header_default = Header;

// src/MainBody.tsx
import classNames2 from "classnames";
import {
  getDate as getDate2,
  isAfter,
  isBefore,
  isFriday,
  isSameDay,
  isSameMonth,
  isToday as isToday2
} from "date-fns-jalali";
import { convertDigits as convertDigits2 } from "persian-helpers";
import { useMemo as useMemo2 } from "react";

// src/utils/getDates.ts
import {
  addDays,
  endOfMonth,
  endOfWeek,
  startOfMonth,
  startOfWeek
} from "date-fns-jalali";
var getDates = (activeDate) => {
  const startOfTheSelectedMonth = startOfMonth(activeDate);
  const endOfTheSelectedMonth = endOfMonth(activeDate);
  const startDate = startOfWeek(startOfTheSelectedMonth);
  const endDate = endOfWeek(endOfTheSelectedMonth);
  let currentDate = startDate;
  const days = [];
  while (currentDate <= endDate) {
    days.push(currentDate);
    currentDate = addDays(currentDate, 1);
  }
  return days;
};

// src/MainBody.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var daysOfTheWeek = [
  "\u0634\u0646\u0628\u0647",
  "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
  "\u062F\u0648\u0634\u0646\u0628\u0647",
  "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
  "\u0686\u0647\u0627\u0631\u200C\u0634\u0646\u0628\u0647",
  "\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647",
  "\u062C\u0645\u0639\u0647"
];
var MainBody = ({
  maxDate,
  minDate,
  onActiveDayChange,
  highlightToday,
  disabledDates,
  themeClasses,
  activeDate,
  selectedDate,
  showFridaysAsRed
}) => {
  const selectedDateDays = useMemo2(
    () => getDates(selectedDate),
    [selectedDate]
  );
  return /* @__PURE__ */ jsxs3(Fragment, {
    children: [
      /* @__PURE__ */ jsx3("div", {
        className: "grid grid-cols-7 gap-4",
        children: ["\u0634", "\u06CC", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C"].map((day, index) => /* @__PURE__ */ jsx3("h2", {
          style: {
            color: themeClasses.weekDaysTextColor,
            backgroundColor: themeClasses.weekDaysBackgroundColor
          },
          className: classNames2(
            "m-0 text-sm rounded-full p-2 w-9 h-9 text-center border border-transparent"
          ),
          "aria-label": daysOfTheWeek[index],
          title: daysOfTheWeek[index],
          children: day
        }, day))
      }),
      /* @__PURE__ */ jsx3("div", {
        className: "grid grid-cols-7 gap-4",
        children: selectedDateDays.map((day, index) => {
          const isDateInvalid = minDate && isBefore(day, minDate) && !isSameDay(day, minDate) || maxDate && isAfter(day, maxDate) && !isSameDay(day, maxDate) || (disabledDates == null ? void 0 : disabledDates.includes(day));
          const textColor = () => {
            if (showFridaysAsRed && isFriday(day))
              return isSameDay(day, activeDate) ? themeClasses.offDaysSelectedColor : themeClasses.offDaysColor;
            if (isSameDay(day, activeDate))
              return themeClasses.daysSelectedColor;
            return themeClasses.daysColor;
          };
          const backgroundColor = () => {
            return isSameDay(day, activeDate) ? themeClasses.daysSelectedBackgroundColor : themeClasses.daysBackgroundColor;
          };
          return /* @__PURE__ */ jsx3("button", {
            disabled: isDateInvalid,
            onClick: onActiveDayChange.bind(void 0, day),
            style: {
              color: textColor(),
              backgroundColor: backgroundColor(),
              borderColor: isToday2(day) && highlightToday ? themeClasses.todayBorderColor : "transparent"
            },
            className: classNames2(
              "text-sm w-9 h-9 rounded-full text-center border m-0",
              (!isSameMonth(day, selectedDate) || isDateInvalid) && "opacity-50"
            ),
            children: convertDigits2(getDate2(day))
          }, day.toString());
        })
      })
    ]
  });
};
var MainBody_default = MainBody;

// src/MonthsBody.tsx
import classNames3 from "classnames";
import { getMonth as getMonth2 } from "date-fns-jalali";
import { jsx as jsx4 } from "react/jsx-runtime";
var MonthsBody = ({
  onChangeMonth,
  months,
  themeClasses,
  selectedDate
}) => {
  return /* @__PURE__ */ jsx4("div", {
    className: "grid grid-cols-3 gap-4",
    children: months.map((month, index) => /* @__PURE__ */ jsx4("button", {
      onClick: () => onChangeMonth(index),
      style: {
        backgroundColor: index === getMonth2(selectedDate) ? themeClasses.daysSelectedBackgroundColor : themeClasses.daysBackgroundColor,
        color: index === getMonth2(selectedDate) ? themeClasses.daysSelectedColor : themeClasses.daysColor
      },
      className: classNames3("px-6 py-4 rounded-full text-center"),
      children: month
    }, month))
  });
};
var MonthsBody_default = MonthsBody;

// src/utils/cloneDate.ts
var cloneDate = (date) => {
  return new Date(date);
};

// src/YearsBody.tsx
import classNames4 from "classnames";
import { getYear } from "date-fns-jalali";
import { convertDigits as convertDigits3 } from "persian-helpers";
import { useCallback, useEffect, useMemo as useMemo3, useRef, useState } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var YearsBody = ({
  onChangeYear,
  activeDate,
  themeClasses,
  selectedDate
}) => {
  const currentYear = useMemo3(() => getYear(new Date()), []);
  const years = [
    ...[...new Array(100)].map((item, index) => currentYear - (100 - index)),
    ...[...new Array(100)].map((item, index) => currentYear + index)
  ];
  const [domNode, setDomNode] = useState(null);
  const currentYearRef = useCallback(setDomNode, []);
  useEffect(() => {
    if (domNode) {
      domNode.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
  }, [domNode]);
  const otherYearsRef = useRef(null);
  return /* @__PURE__ */ jsx5("div", {
    className: "grid grid-cols-3 gap-4 max-h-72 overflow-y-scroll custom-scroll",
    children: years.map((year, index) => /* @__PURE__ */ jsx5("button", {
      ref: year === getYear(selectedDate) ? currentYearRef : otherYearsRef,
      onClick: () => onChangeYear(year),
      style: {
        backgroundColor: year === getYear(selectedDate) ? themeClasses.daysSelectedBackgroundColor : themeClasses.daysBackgroundColor,
        color: year === getYear(selectedDate) ? themeClasses.daysSelectedColor : themeClasses.daysColor
      },
      className: classNames4("px-6 py-4 rounded-full text-center"),
      children: convertDigits3(year)
    }, year))
  });
};
var YearsBody_default = YearsBody;

// src/Calendar.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var FadeTransition = ({ children, bodyTransition, ...rest }) => /* @__PURE__ */ jsx6(Transition, {
  ...rest,
  children: (state) => {
    let transitionClass;
    switch (bodyTransition) {
      case "fade":
        transitionClass = { in: "opacity-100", out: "opacity-0" };
        break;
      case "zoomOut":
        transitionClass = {
          in: "opacity-100 scale-100",
          out: "opacity-0 scale-50"
        };
        break;
      default:
      case "zoomIn":
        transitionClass = {
          in: "opacity-100 scale-100",
          out: "opacity-0 scale-110"
        };
        break;
    }
    return /* @__PURE__ */ jsx6("div", {
      className: classNames5(
        state === "exiting" || state === "entering" ? "absolute top-0" : "relative",
        state === "entered" ? transitionClass.in : transitionClass.out,
        state === "exited" ? "hidden" : "block",
        "transition-all ease-in-out w-full h-full flex flex-col space-y-4"
      ),
      children
    });
  }
});
var getInitialDate = (defaultActiveDate, propActiveDate, minDate) => {
  if (defaultActiveDate)
    return defaultActiveDate;
  if (propActiveDate)
    return propActiveDate;
  if (minDate) {
    let clonedMin = cloneDate(minDate);
    while (clonedMin <= minDate) {
      clonedMin.setDate(clonedMin.getDate() + 1);
    }
    return clonedMin;
  }
  return new Date();
};
var Calendar = forwardRef(
  ({
    highlightToday = true,
    onChange,
    activeDate: propActiveDate,
    theme = "light",
    showGoToToday = true,
    defaultActiveDate,
    minDate,
    maxDate,
    showFooter = false,
    disabledDates,
    disableTransitions,
    bodyTransition = "zoomIn",
    style,
    showFridaysAsRed = true,
    showTimePicker = true,
    presistTimeOnDateChange = false,
    months = [
      "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
      "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
      "\u062E\u0631\u062F\u0627\u062F",
      "\u062A\u06CC\u0631",
      "\u0645\u0631\u062F\u0627\u062F",
      "\u0634\u0647\u0631\u06CC\u0648\u0631",
      "\u0645\u0647\u0631",
      "\u0622\u0628\u0627\u0646",
      "\u0622\u0630\u0631",
      "\u062F\u06CC",
      "\u0628\u0647\u0645\u0646",
      "\u0627\u0633\u0641\u0646\u062F"
    ],
    onCancel,
    onConfirm
  }, ref) => {
    const [activeDate, setActiveDate] = useState2(
      getInitialDate(defaultActiveDate, propActiveDate, minDate)
    );
    const [selectedDate, setSelectedDate] = useState2(activeDate);
    const [activeBody, setActiveBody] = useState2(
      "main"
    );
    const [mode, setMode] = useState2("date");
    const [hour, setHour] = useState2(
      (propActiveDate == null ? void 0 : propActiveDate.getHours()) || (defaultActiveDate == null ? void 0 : defaultActiveDate.getHours()) || 0
    );
    const [minute, setMinute] = useState2(
      (propActiveDate == null ? void 0 : propActiveDate.getMinutes()) || (defaultActiveDate == null ? void 0 : defaultActiveDate.getMinutes()) || 0
    );
    useEffect2(() => {
      if (propActiveDate)
        setActiveDate(activeDate);
    }, [propActiveDate]);
    useEffect2(() => {
      setActiveDate((previousActiveDate) => {
        const previousActiveDateCopy = new Date(previousActiveDate);
        previousActiveDateCopy.setHours(hour, minute, 0, 0);
        return previousActiveDateCopy;
      });
    }, [hour, minute]);
    const activeDayChangeHandler = (day) => {
      const dayCopy = new Date(day);
      if (presistTimeOnDateChange) {
        dayCopy.setHours(hour, minute, 0, 0);
      } else
        dayCopy.setHours(0, 0, 0);
      setActiveDate(dayCopy);
    };
    const goToTodayHandler = () => {
      activeDayChangeHandler(new Date());
    };
    const nextMonthHandler = () => {
      setSelectedDate((previousDate) => addMonths(previousDate, 1));
    };
    const previousMonthHandler = () => {
      setSelectedDate((previousDate) => subMonths(previousDate, 1));
    };
    const monthChangeHandler = (month) => {
      setSelectedDate((previousDate) => setMonth(previousDate, month));
    };
    const yearChangeHandler = (year) => {
      setSelectedDate((previousDate) => setYear(previousDate, year));
    };
    const cycleThroughBodies = () => {
      if (activeBody === "main")
        return setActiveBody("months");
      if (activeBody === "months")
        return setActiveBody("years");
      return setActiveBody("main");
    };
    const goToPreviousBody = () => {
      if (activeBody === "years")
        return setActiveBody("months");
      setActiveBody("main");
    };
    useEffect2(() => {
      setSelectedDate(activeDate);
      onChange == null ? void 0 : onChange(activeDate);
    }, [activeDate]);
    useEffect2(() => {
      goToPreviousBody();
    }, [selectedDate]);
    const compareMinDate = () => {
      if (!minDate)
        return false;
      const minDateClone = new Date(minDate);
      const now = new Date();
      minDateClone.setHours(0, 0, 0);
      now.setHours(0, 0, 0);
      return now > minDate;
    };
    const themeClasses = useMemo4(() => {
      switch (theme) {
        case "light":
          return {
            bodyBackgroundColor: "#fff",
            chevronLeftColor: "#6b7280",
            chevronRightColor: "#6b7280",
            topBarTextColor: "#6b7280",
            weekDaysBackgroundColor: "#f3f4f6",
            weekDaysTextColor: "#9ca3af",
            daysBackgroundColor: "transparent",
            daysSelectedBackgroundColor: "#3b82f6",
            todayBorderColor: "#3b82f6",
            daysSelectedColor: "#fff",
            daysColor: "#000",
            footerBackgroundColor: "#f1f5f9",
            footerButtonColor: "#3b82f6",
            headerBackgroundColor: "#0284c7",
            headerTextColor: "#fff",
            offDaysColor: "#ef4444",
            offDaysSelectedColor: "#fee2e2",
            clock: defaultTimePickerTheme
          };
        case "dark":
          return {
            bodyBackgroundColor: "#1c1917",
            chevronLeftColor: "#e7e5e4",
            chevronRightColor: "#e7e5e4",
            topBarTextColor: "#e7e5e4",
            weekDaysBackgroundColor: "#78716c",
            weekDaysTextColor: "#d6d3d1",
            daysBackgroundColor: "transparent",
            daysSelectedBackgroundColor: "#3b82f6",
            todayBorderColor: "#3b82f6",
            daysSelectedColor: "#fff",
            daysColor: "#fff",
            footerBackgroundColor: "#292524",
            footerButtonColor: "#3b82f6",
            headerBackgroundColor: "#0284c7",
            headerTextColor: "#fff",
            offDaysColor: "#ef4444",
            offDaysSelectedColor: "#fee2e2",
            clock: {
              backgroundColor: "#1c1917",
              amPmActiveBackgroundColor: "#3b82f6",
              amPmColor: "#fff",
              clockBackgroundColor: "#000",
              clockLabelsColor: "#fff",
              pointerBackgroundColor: "#38bdf8"
            }
          };
        case "darkRed":
          return {
            bodyBackgroundColor: "#1c1917",
            chevronLeftColor: "#e7e5e4",
            chevronRightColor: "#e7e5e4",
            topBarTextColor: "#e7e5e4",
            weekDaysBackgroundColor: "#78716c",
            weekDaysTextColor: "#d6d3d1",
            daysBackgroundColor: "transparent",
            daysSelectedBackgroundColor: "#f43f5e",
            todayBorderColor: "#f43f5e",
            daysSelectedColor: "#fff",
            daysColor: "#fff",
            footerBackgroundColor: "#292524",
            footerButtonColor: "#f43f5e",
            headerBackgroundColor: "#e11d48",
            headerTextColor: "#fff",
            offDaysColor: "#ef4444",
            offDaysSelectedColor: "#fee2e2",
            clock: {
              backgroundColor: "#1c1917",
              amPmActiveBackgroundColor: "#f43f5e",
              amPmColor: "#fff",
              clockBackgroundColor: "#000",
              clockLabelsColor: "#fff",
              pointerBackgroundColor: "#fb7185"
            }
          };
        default:
          return theme;
      }
    }, [theme]);
    useEffect2(() => {
      if (months.length !== 12)
        throw new Error("\u0637\u0648\u0644 \u0622\u0631\u0627\u06CC\u0647 \u0645\u0627\u0647 \u0647\u0627\u06CC \u0648\u0627\u0631\u062F \u0634\u062F\u0647\u060C \u0645\u06CC \u0628\u0627\u06CC\u0633\u062A 12 \u0628\u0627\u0634\u062F.");
    }, [months]);
    const Body = useMemo4(() => {
      return activeBody === "main" ? /* @__PURE__ */ jsx6(MainBody_default, {
        activeDate,
        disabledDates: disabledDates == null ? void 0 : disabledDates.map((disabledDate) => {
          const clonedDate = cloneDate(disabledDate);
          clonedDate.setHours(0, 0, 0);
          return clonedDate;
        }),
        highlightToday,
        maxDate,
        minDate,
        onActiveDayChange: activeDayChangeHandler,
        selectedDate,
        themeClasses,
        showFridaysAsRed
      }) : activeBody === "months" ? /* @__PURE__ */ jsx6(MonthsBody_default, {
        themeClasses,
        onChangeMonth: monthChangeHandler,
        selectedDate,
        months
      }) : /* @__PURE__ */ jsx6(YearsBody_default, {
        themeClasses,
        onChangeYear: yearChangeHandler,
        activeDate,
        selectedDate
      });
    }, [
      activeBody,
      activeDate,
      disabledDates,
      highlightToday,
      maxDate,
      minDate,
      activeDayChangeHandler,
      selectedDate,
      themeClasses
    ]);
    return /* @__PURE__ */ jsxs4("div", {
      ref,
      style: { fontFamily: "Vazirmatn", ...style },
      className: "flex flex-col rounded-md shadow-lg max-w-[22rem] overflow-hidden",
      dir: "rtl",
      children: [
        /* @__PURE__ */ jsx6(Header_default, {
          activeDate,
          selectedDate,
          onGoToToday: goToTodayHandler,
          showGoToToday: minDate ? compareMinDate() : showGoToToday,
          months,
          themeClasses
        }),
        mode === "date" ? /* @__PURE__ */ jsxs4("div", {
          style: { backgroundColor: themeClasses.bodyBackgroundColor },
          className: classNames5("p-4 flex flex-col items-center space-y-6"),
          children: [
            /* @__PURE__ */ jsxs4("div", {
              className: "flex items-center justify-between text-gray-500 w-full",
              children: [
                /* @__PURE__ */ jsx6("button", {
                  onClick: previousMonthHandler,
                  style: { color: themeClasses.chevronRightColor },
                  children: /* @__PURE__ */ jsx6(wH, {
                    className: "w-4 h-4"
                  })
                }),
                /* @__PURE__ */ jsxs4("button", {
                  className: "text-base",
                  onClick: cycleThroughBodies,
                  style: { color: themeClasses.topBarTextColor },
                  children: [
                    activeBody === "main" && months[getMonth3(selectedDate)],
                    " ",
                    convertDigits4(format2(selectedDate, "yyyy"))
                  ]
                }),
                /* @__PURE__ */ jsx6("button", {
                  onClick: nextMonthHandler,
                  style: { color: themeClasses.chevronLeftColor },
                  children: /* @__PURE__ */ jsx6(mH, {
                    className: "w-4 h-4"
                  })
                })
              ]
            }),
            disableTransitions ? Body : /* @__PURE__ */ jsx6("div", {
              className: "relative",
              children: /* @__PURE__ */ jsx6(SwitchTransition, {
                mode: "in-out",
                children: /* @__PURE__ */ jsx6(FadeTransition, {
                  bodyTransition,
                  timeout: 200,
                  unmountOnExit: true,
                  mountOnEnter: true,
                  children: Body
                }, activeBody)
              })
            })
          ]
        }) : /* @__PURE__ */ jsx6(TimePicker, {
          onChange: (hour2, minute2) => {
            setHour(hour2);
            setMinute(minute2);
            setMode("date");
          },
          theme: themeClasses.clock
        }),
        showFooter && /* @__PURE__ */ jsx6(Footer_default, {
          themeClasses,
          onConfirm: () => onConfirm == null ? void 0 : onConfirm(activeDate),
          onCancel,
          showTimePicker,
          mode,
          onChangeMode: setMode
        })
      ]
    });
  }
);
export {
  Calendar
};
